import React, { useMemo, useState } from 'react';
import { usePresentationMaker } from 'features/ai-generators/hooks';
import strings from 'strings';

import { PresentationMakerDefaultState } from '../detail-panels';
import { PresentationMakerGeneratorDrawer } from '../PresentationMakerGeneratorDrawer';

export const PresentationMakerTemplate = ({
  buildSourceParamsFn,
  generatePresentationFn,
  initialPresentationTypeId,
  leftContent,
  onClose,
  open = true,
  rightContentFooter,
  sourceData,
  subtitle,
  title
}) => {
  const [presentationTypeId, setPresentationTypeId] = useState(initialPresentationTypeId || null);
  const typeParam = useMemo(
    () => (presentationTypeId ? { type: presentationTypeId } : {}),
    [presentationTypeId]
  );
  const {
    generatedAiData,
    handleClickRateButton,
    handleGenerateWithAi,
    uiState: uiStatePresentationMaker
  } = usePresentationMaker({
    sourceData,
    buildSourceParamsFn,
    generatePresentationFn,
    extendedParams: typeParam
  });

  const handleSelectType = typeId => {
    if (typeId === presentationTypeId) return;
    setPresentationTypeId(typeId);
  };

  const leftContentRendered = leftContent
    ? leftContent({
        onSelectPresentationType: handleSelectType,
        isEnabled: !uiStatePresentationMaker?.isLoading
      })
    : null;

  const rightContentFooterRendered = rightContentFooter
    ? rightContentFooter({
        presentationTypeId
      })
    : null;

  return (
    <PresentationMakerGeneratorDrawer
      defaultPresentationContent={generatedAiData}
      isFormEnabled={!!presentationTypeId}
      leftContent={leftContentRendered}
      onClickGenerate={presentationTypeId && sourceData && handleGenerateWithAi}
      onClickRateButton={handleClickRateButton}
      onClose={() => {
        setPresentationTypeId(null);
        onClose && onClose();
      }}
      open={open}
      optionsExtendedParams={typeParam}
      presentationTypeId={presentationTypeId}
      renderInitialState={PresentationMakerDefaultState}
      rightContentFooter={rightContentFooterRendered}
      submitButtonName={strings.ai.generators.actions.regenerate}
      subtitle={subtitle}
      title={title || strings.ai.generators.presentationsMaker.title}
    />
  );
};
